"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findBestMatch = exports.calculateSimilarity = exports.findSynonymMatch = exports.tokenMatchScore = exports.jaroWinklerSimilarity = exports.normalizeString = exports.tokenize = exports.MatchType = exports.COLUMN_SYNONYMS = void 0;
exports.COLUMN_SYNONYMS = {
    email: ['e-mail', 'emailaddress', 'mail', 'correo', 'emailid', 'user_email', 'contact_email'],
    phone: ['telephone', 'tel', 'mobile', 'cell', 'telefono', 'phonenumber', 'contact_number', 'mobilenumber'],
    name: ['fullname', 'nombre', 'customer_name', 'displayname', 'contact_name'],
    firstname: ['first_name', 'fname', 'givenname', 'given_name', 'forename'],
    lastname: ['last_name', 'lname', 'surname', 'familyname', 'family_name'],
    middlename: ['middle_name', 'mname', 'middleinitial', 'middle_initial'],
    address: ['street', 'streetaddress', 'street_address', 'direccion', 'addr', 'address1', 'addressline1'],
    city: ['town', 'ciudad', 'locality'],
    state: ['province', 'region', 'estado', 'county'],
    country: ['nation', 'pais', 'countryname', 'country_name'],
    zipcode: ['zip', 'postalcode', 'postal_code', 'postcode', 'zip_code', 'pincode', 'pin_code'],
    company: ['organization', 'organisation', 'companyname', 'company_name', 'business', 'employer', 'firm'],
    department: ['dept', 'division', 'unit', 'team'],
    jobtitle: ['job_title', 'title', 'position', 'role', 'designation'],
    date: ['fecha', 'dt', 'datetime'],
    birthdate: ['birthday', 'dob', 'dateofbirth', 'date_of_birth', 'birth_date'],
    createdat: ['created_at', 'creationdate', 'creation_date', 'datecreated', 'date_created'],
    updatedat: ['updated_at', 'modifieddate', 'modified_date', 'datemodified', 'date_modified', 'lastmodified'],
    id: ['identifier', 'uid', 'uuid', 'key', 'code'],
    customerid: ['customer_id', 'custid', 'cust_id', 'clientid', 'client_id'],
    orderid: ['order_id', 'orderno', 'order_no', 'ordernumber', 'order_number'],
    productid: ['product_id', 'productcode', 'product_code', 'sku', 'itemid', 'item_id'],
    amount: ['total', 'sum', 'value', 'price', 'cost', 'monto', 'precio'],
    quantity: ['qty', 'count', 'cantidad', 'units', 'number'],
    percentage: ['percent', 'pct', 'rate', 'porcentaje'],
    status: ['state', 'estado', 'condition'],
    active: ['enabled', 'isactive', 'is_active'],
    description: ['desc', 'details', 'descripcion', 'notes', 'comments', 'remarks'],
    website: ['url', 'web', 'homepage', 'site', 'webpage'],
    username: ['user_name', 'login', 'userid', 'user_id', 'handle'],
    password: ['pwd', 'pass', 'secret'],
    gender: ['sex', 'genero'],
    age: ['edad', 'years'],
    image: ['photo', 'picture', 'avatar', 'img', 'imagen', 'foto'],
    file: ['document', 'attachment', 'archivo'],
    category: ['type', 'categoria', 'group', 'class'],
    tags: ['labels', 'keywords', 'etiquetas'],
};
var MatchType;
(function (MatchType) {
    MatchType["EXACT"] = "exact";
    MatchType["NORMALIZED_EXACT"] = "normalized_exact";
    MatchType["SYNONYM"] = "synonym";
    MatchType["JARO_WINKLER"] = "jaro_winkler";
    MatchType["TOKEN_MATCH"] = "token_match";
    MatchType["SUBSTRING"] = "substring";
    MatchType["NO_MATCH"] = "no_match";
})(MatchType = exports.MatchType || (exports.MatchType = {}));
function tokenize(str) {
    if (!str)
        return [];
    return (str
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/[-_./\\]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase()
        .split(' ')
        .filter((token) => token.length > 0));
}
exports.tokenize = tokenize;
function normalizeString(str) {
    if (!str)
        return '';
    return (String(str)
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s_-]/g, ''));
}
exports.normalizeString = normalizeString;
function jaroSimilarity(s1, s2) {
    if (s1 === s2)
        return 1;
    if (s1.length === 0 || s2.length === 0)
        return 0;
    const matchDistance = Math.floor(Math.max(s1.length, s2.length) / 2) - 1;
    const s1Matches = new Array(s1.length).fill(false);
    const s2Matches = new Array(s2.length).fill(false);
    let matches = 0;
    let transpositions = 0;
    for (let i = 0; i < s1.length; i++) {
        const start = Math.max(0, i - matchDistance);
        const end = Math.min(i + matchDistance + 1, s2.length);
        for (let j = start; j < end; j++) {
            if (s2Matches[j] || s1[i] !== s2[j])
                continue;
            s1Matches[i] = true;
            s2Matches[j] = true;
            matches++;
            break;
        }
    }
    if (matches === 0)
        return 0;
    let k = 0;
    for (let i = 0; i < s1.length; i++) {
        if (!s1Matches[i])
            continue;
        while (!s2Matches[k])
            k++;
        if (s1[i] !== s2[k])
            transpositions++;
        k++;
    }
    return (matches / s1.length + matches / s2.length + (matches - transpositions / 2) / matches) / 3;
}
function jaroWinklerSimilarity(s1, s2, prefixScale = 0.1) {
    const jaro = jaroSimilarity(s1, s2);
    let prefixLength = 0;
    const maxPrefix = Math.min(4, Math.min(s1.length, s2.length));
    for (let i = 0; i < maxPrefix; i++) {
        if (s1[i] === s2[i]) {
            prefixLength++;
        }
        else {
            break;
        }
    }
    const scale = Math.min(prefixScale, 0.25);
    return jaro + prefixLength * scale * (1 - jaro);
}
exports.jaroWinklerSimilarity = jaroWinklerSimilarity;
function tokenMatchScore(tokens1, tokens2) {
    if (tokens1.length === 0 || tokens2.length === 0)
        return 0;
    const set1 = new Set(tokens1);
    const set2 = new Set(tokens2);
    let matches = 0;
    for (const token of set1) {
        if (set2.has(token)) {
            matches++;
        }
    }
    const minSize = Math.min(set1.size, set2.size);
    return matches / minSize;
}
exports.tokenMatchScore = tokenMatchScore;
function findSynonymMatch(key, synonymDict = exports.COLUMN_SYNONYMS) {
    const normalizedKey = normalizeString(key).replace(/[-_\s]/g, '');
    if (synonymDict[normalizedKey]) {
        return normalizedKey;
    }
    for (const [canonical, synonyms] of Object.entries(synonymDict)) {
        const normalizedCanonical = normalizeString(canonical).replace(/[-_\s]/g, '');
        if (normalizedKey === normalizedCanonical) {
            return canonical;
        }
        for (const synonym of synonyms) {
            const normalizedSynonym = normalizeString(synonym).replace(/[-_\s]/g, '');
            if (normalizedKey === normalizedSynonym) {
                return canonical;
            }
        }
    }
    return null;
}
exports.findSynonymMatch = findSynonymMatch;
function calculateSimilarity(str1, str2) {
    if (!str1 || !str2) {
        return { score: 0, matchType: MatchType.NO_MATCH };
    }
    const s1 = String(str1).trim();
    const s2 = String(str2).trim();
    if (s1 === s2) {
        return { score: 1, matchType: MatchType.EXACT };
    }
    const normalized1 = normalizeString(s1);
    const normalized2 = normalizeString(s2);
    if (normalized1 === normalized2) {
        return { score: 0.99, matchType: MatchType.NORMALIZED_EXACT };
    }
    const stripped1 = normalized1.replace(/[-_\s]/g, '');
    const stripped2 = normalized2.replace(/[-_\s]/g, '');
    if (stripped1 === stripped2) {
        return { score: 0.98, matchType: MatchType.NORMALIZED_EXACT };
    }
    const synonym1 = findSynonymMatch(s1);
    const synonym2 = findSynonymMatch(s2);
    if (synonym1 && synonym2 && synonym1 === synonym2) {
        return { score: 0.95, matchType: MatchType.SYNONYM };
    }
    const tokens1 = tokenize(s1);
    const tokens2 = tokenize(s2);
    const tokenScore = tokenMatchScore(tokens1, tokens2);
    if (tokenScore >= 0.8) {
        return { score: 0.85 + tokenScore * 0.1, matchType: MatchType.TOKEN_MATCH };
    }
    const jwScore = jaroWinklerSimilarity(stripped1, stripped2);
    if (jwScore >= 0.85) {
        return { score: jwScore * 0.9, matchType: MatchType.JARO_WINKLER };
    }
    if (stripped1.length >= 3 && stripped2.length >= 3) {
        if (stripped1.includes(stripped2) || stripped2.includes(stripped1)) {
            const lengthRatio = Math.min(stripped1.length, stripped2.length) / Math.max(stripped1.length, stripped2.length);
            return { score: 0.7 + lengthRatio * 0.15, matchType: MatchType.SUBSTRING };
        }
    }
    if (tokenScore >= 0.5) {
        return { score: 0.5 + tokenScore * 0.2, matchType: MatchType.TOKEN_MATCH };
    }
    if (jwScore >= 0.7) {
        return { score: jwScore * 0.7, matchType: MatchType.JARO_WINKLER };
    }
    return { score: 0, matchType: MatchType.NO_MATCH };
}
exports.calculateSimilarity = calculateSimilarity;
function findBestMatch(headings, key, alternateKeys = [], threshold = 0.6) {
    let bestIndex = -1;
    let bestScore = 0;
    let bestMatchType = MatchType.NO_MATCH;
    const keysToMatch = [key, ...alternateKeys];
    for (let i = 0; i < headings.length; i++) {
        const heading = headings[i];
        for (const matchKey of keysToMatch) {
            const result = calculateSimilarity(heading, matchKey);
            if (result.score > bestScore) {
                bestScore = result.score;
                bestIndex = i;
                bestMatchType = result.matchType;
            }
            if (bestScore >= 0.98) {
                return { index: bestIndex, score: bestScore, matchType: bestMatchType };
            }
        }
    }
    if (bestScore >= threshold) {
        return { index: bestIndex, score: bestScore, matchType: bestMatchType };
    }
    return { index: -1, score: 0, matchType: MatchType.NO_MATCH };
}
exports.findBestMatch = findBestMatch;
